import { render } from "./AddApp.vue?vue&type=template&id=5d06fcfb"
import script from "./AddApp.vue?vue&type=script&lang=js"
export * from "./AddApp.vue?vue&type=script&lang=js"

import "./AddApp.vue?vue&type=style&index=0&id=5d06fcfb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__